import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "../components/AuthContext";
import { Field } from "./Login";

export default function Register() {
  const [form, setForm] = useState({ name: "", firm_name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const update = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await register(form); navigate("/dashboard"); }
    catch (err) { setError(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center px-8 py-12 md:px-20 max-w-2xl mx-auto">
      <div className="overline mb-3">Create your firm</div>
      <h1 className="font-heading text-4xl mb-2" style={{ fontWeight: 500 }}>Start with your firm.</h1>
      <p className="text-[var(--ink-2)] mb-8">One workspace for your team. You become the owner.</p>

      <form onSubmit={onSubmit} data-testid="register-form" className="space-y-4 max-w-md">
        <Field id="firm" label="Firm Name" value={form.firm_name} onChange={update("firm_name")} testid="register-firm-name" />
        <Field id="name" label="Your Name" value={form.name} onChange={update("name")} testid="register-name" />
        <Field id="email" label="Email" type="email" value={form.email} onChange={update("email")} testid="register-email" autoComplete="email" />
        <Field id="password" label="Password (min 8)" type="password" value={form.password} onChange={update("password")} testid="register-password" autoComplete="new-password" />
        {error && <div className="text-[13px] text-[var(--accent)]" data-testid="register-error">{error}</div>}
        <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="register-submit">
          {loading ? "Creating…" : "Create firm"}
        </button>
      </form>

      <div className="text-[13px] text-[var(--ink-2)] mt-6 max-w-md">
        Already have an account?{" "}
        <Link to="/login" className="text-[var(--accent)] hover:underline" data-testid="link-login">Sign in</Link>
      </div>
    </div>
  );
}
